import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { selects } from '../../constants/selects.const';
import { MessageService } from 'primeng/api';
import { User } from '@bl-interfaces/user';

@Component({
  selector: 'bid-users-role-table',
  templateUrl: './users-role-table.component.html',
  styleUrls: ['./users-role-table.component.scss'],
})
export class UsersRoleTableComponent implements OnInit {
  @Input() headerTable: any;
  @Input() bodyTable: any;
  @Input() updateForm: any;
  // eslint-disable-next-line
  @Output() onDelete: EventEmitter<User> = new EventEmitter<User>();
  // eslint-disable-next-line
  @Output() onStatusChange: EventEmitter<User> = new EventEmitter<User>();
  userName: string = '';
  userEmail: string = '';
  rolesCombo: any;
  updateRoleUser: number = -1;
  display: boolean = false;
  addUser: any = {};
  status: boolean = false;
  displayDelete: boolean = false;
  displayDisable: boolean = false;
  userData!: User;
  colUser: number = -1;

  constructor(private messageService: MessageService) {
    this.userName = '';
    this.userEmail = '';
  }

  ngOnInit() {
    this.rolesCombo = selects.pages.users.roles;
  }

  showToastSuccess(title: string, msg: string, key: string) {
    this.messageService.add({
      key,
      severity: 'success',
      summary: title,
      detail: msg,
    });
  }

  toggleDialogDelete(user: any, display: any) {
    this.displayDelete = display;
    this.userData = {
      displayName: user.displayName,
      mail: user.mail,
      role: user.role,
      status: user.status,
    };
  }

  deleteUser(event: any) {
    this.displayDelete = false;
    if (event.submit) {
      this.onDelete.emit(event.user);
    }
  }

  updateStatus(user: any) {
    this.onStatusChange.emit(user);
  }
}
